module.exports = __webpack_public_path__ + "img/img5.8b0a249e.png";